var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.8076,
    r: 20,
    fill: "#FFE26D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66677,
    cy: 28.8079,
    r: 3.11111,
    fill: "#F6D655"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3338,
    cy: 27.9187,
    r: 3.11111,
    fill: "#F6D655"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.88813,
    cy: 22.1415,
    r: 1.77778,
    fill: "#F6D655"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4448,
    cy: 33.6962,
    r: 1.77778,
    fill: "#F6D655"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.459,
    y: 31.9766,
    width: 21.3333,
    height: 4.26667,
    transform: "rotate(-90 12.459 31.9766)",
    fill: "#7A6C31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6816,
    y: 14.9102,
    width: 14.2222,
    height: 4.26667,
    transform: "rotate(-180 26.6816 14.9102)",
    fill: "#7A6C31"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.127,
    y: 23.7993,
    width: 10.6667,
    height: 4.26667,
    transform: "rotate(-180 23.127 23.7993)",
    fill: "#7A6C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile_logo.dc4ee9c366e25ca03a7f5837420f8931.svg";
export { ForwardRef as ReactComponent };